import {isBefore, parse} from 'date-fns';

/**
 * Is date in the past
 * @param date `yyyy-MM-dd`
 * @return `true` if date is in the past
 *
 * @example
 * ```ts
 * const inThePast = isDateInThePast('2021-01-01');
 * ```
 */
export const isDateInThePast = (date?: string | null) => {
	return (
		date != null &&
		date != '' &&
		isBefore(parse(date, 'yyyy-MM-dd', new Date()), new Date())
	);
};
